import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "disabled", "invalid", "inline", "leftAdornment", "rightAdornment", "children", "cursor", "size", "width", "minWidth", "maxWidth", "focused"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { mergeStyles } from '../../utils';
import { useInputSize, InputSizeContext } from '../../hooks';
import { InputAdornment } from '../../../inputAdornment';
import { Spinner } from '../../../loader';
import * as inputGroupStyles from '../../../internal/styles/inputWrapperGroup.module.css';
import * as inputAdornmentStyles from '../../../internal/styles/inputWrapperAdornment.module.css';
import { getStyles } from './styles/getStyles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var InputWrapper = /*#__PURE__*/React.forwardRef(function InputWrapper(props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    leftAdornment = props.leftAdornment,
    rightAdornment = props.rightAdornment,
    children = props.children,
    cursor = props.cursor,
    sizeProp = props.size,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    focused = props.focused,
    rest = _objectWithoutProperties(props, _excluded);
  var size = useInputSize(sizeProp);
  var styles = mergeStyles(getStyles(size), inputGroupStyles, inputAdornmentStyles);
  var leftAdornmentContent = leftAdornment;
  var rightAdornmentContent = loading ? /*#__PURE__*/_jsx(InputAdornment, {
    children: /*#__PURE__*/_jsx(Spinner, {
      color: "icon-secondary-default",
      size: 16
    })
  }) : rightAdornment;
  return /*#__PURE__*/_jsx(InputSizeContext.Provider, {
    value: size,
    children: /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
      ref: ref,
      className: clsx(styles['input-wrapper'], focused && styles['focused'], invalid && styles['invalid'], disabled && styles['disabled'], inline && styles['inline'], props.className),
      style: {
        cursor: cursor,
        width: width,
        minWidth: minWidth,
        maxWidth: maxWidth
      },
      tabIndex: disabled ? -1 : props.tabIndex,
      children: [leftAdornmentContent && /*#__PURE__*/_jsx("span", {
        className: styles['left-adornment'],
        children: leftAdornmentContent
      }), /*#__PURE__*/_jsx("div", {
        className: styles['children-wrapper'],
        children: children
      }), rightAdornmentContent && /*#__PURE__*/_jsx("span", {
        className: styles['right-adornment'],
        children: rightAdornmentContent
      })]
    }))
  });
});